import { render, staticRenderFns } from "./forex.vue?vue&type=template&id=11703cea&scoped=true"
import script from "./forex.vue?vue&type=script&lang=js"
export * from "./forex.vue?vue&type=script&lang=js"
import style0 from "./forex.vue?vue&type=style&index=0&id=11703cea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11703cea",
  null
  
)

export default component.exports